// extracted by mini-css-extract-plugin
module.exports = {"information-form":"InformationForm_information-form__V9BrD","inputs":"InformationForm_inputs__Pt6KD"};